import {
	BellIcon,
	BrandsIcon,
	BulbIcon,
	ColouredLogo,
	LogoWithoutText,
	MenuIcon,
	PlayIcon,
	ProjectsIcon,
	RightArrowIcon,
	SettingsIcon,
	UpgradeIcon,
} from '../icons'

import { useHistory } from 'react-router-dom'

//tippyjs
import Tippy from '@tippyjs/react'
import { WhatsNew } from './menus/whatsnew'
import { BellNotifications } from './menus/bellNotifications'
import { Logout } from './logout'
import { useState } from 'react'
import { MobileNvabar } from './menus/MobileNavbar'

interface MainLayoutI {
	currentRoute?: string
}

export const MainLayout: React.FC<MainLayoutI> = ({
	children,
	currentRoute,
}) => {
	const { push } = useHistory()

	//local state
	const [openMobileNavbar, setOpenMobileNavbar] = useState<boolean>(false)

	// const activeButton = (route: string): React.CSSProperties => ({
	// 	backgroundColor: currentRoute === route ? '#ff3067' : '',
	// 	borderColor: currentRoute === route ? '#ff3067' : '',
	// 	color: currentRoute === route ? '#fffff' : '',
	// })
	return (
		<>
			<MobileNvabar
				isOpen={openMobileNavbar}
				handleClose={() => setOpenMobileNavbar(false)}
			/>
			<div className='container'>
				<div className='main-layout'>
					<section className='left-section'>
						<section className='top-area'>
							<ColouredLogo />
							<section className='content-list'>
								<h5>
									<div>
										<BrandsIcon /> Brands
									</div>
									<RightArrowIcon />
								</h5>
								<h5>
									<div>
										<ProjectsIcon /> Projects
									</div>
									<RightArrowIcon />
								</h5>
								<h5>
									<div>
										<SettingsIcon /> Settings
									</div>
									<RightArrowIcon />
								</h5>
							</section>
						</section>
						<section className='down-area'>
							<h5>Premium Pack</h5>
							<section className='premium-pac-bar'>
								<section className='content'>
									<small>Monthly</small>
									<small>90 / 100</small>
								</section>
								<div className='progress-bar-container'>
									<div className='progress-bar' />
								</div>
							</section>
							<small>Resets in 3 weeks</small>
						</section>
					</section>
					<section className='right-section'>
						<section className='top-area'>
							<section className='left-area'>
								<div>
									<button
										// style={activeButton('/howdoesitwork')}
										onClick={() => push('/howdoesitwork')}>
										<p
										// style={{
										// 	color: currentRoute === '/howdoesitwork' ? 'white' : '',
										// }}
										>
											How does it work?
										</p>
										<div>
											{' '}
											<PlayIcon />
										</div>
									</button>
									<Tippy
										interactive={true}
										placement={'bottom'}
										content={<WhatsNew />}>
										<button>
											What's New?{' '}
											<div>
												{' '}
												<BulbIcon />
											</div>
										</button>
									</Tippy>
								</div>
							</section>
							<section className='right-area'>
								<button>
									<div>
										<UpgradeIcon />
									</div>{' '}
									Upgrade
								</button>
								<Tippy
									interactive={true}
									placement={'bottom'}
									content={<BellNotifications />}>
									<button>
										<BellIcon />
									</button>
								</Tippy>
								<Tippy
									interactive={true}
									placement={'bottom'}
									content={<Logout />}>
									<button>EM</button>
								</Tippy>
							</section>
						</section>
						<section className='down-area'>
							<section className='mobile-nav-menu'>
								<div>
									<LogoWithoutText />
									<MenuIcon onClick={() => setOpenMobileNavbar(true)} />
								</div>
							</section>
							{children}
						</section>
					</section>
				</div>
			</div>
		</>
	)
}
